module.exports = __webpack_public_path__ + "static/media/gallery14.01268344.jpeg";